import { ArrowUp } from 'lucide-react';
import { useEffect, useState } from 'react';
import { scrollMotion } from './motion.js';
import { useSnackbarSpace } from './use-snackbar.js';

export function BackToTop({ threshold = 480 }: { threshold?: number }) {
  const [visible, setVisible] = useState(() => window.scrollY > threshold);
  // O aviso e este botão disputam o mesmo canto. Quem chegou por último sobe: esconder o botão
  // enquanto o aviso está na tela tiraria da pessoa justamente o atalho para voltar ao formulário.
  const stack = useSnackbarSpace();

  useEffect(() => {
    const updateVisibility = () => setVisible(window.scrollY > threshold);
    window.addEventListener('scroll', updateVisibility, { passive: true });
    updateVisibility();
    return () => window.removeEventListener('scroll', updateVisibility);
  }, [threshold]);

  if (!visible) return null;
  return (
    <button
      type="button"
      aria-label="Voltar ao topo"
      onClick={() => window.scrollTo({ top: 0, behavior: scrollMotion() })}
      {...(stack > 0 ? { style: { bottom: stack + 8 } } : {})}
      className="fixed bottom-5 right-5 z-50 grid size-11 place-items-center rounded-full border border-brand-500/35 bg-surface-card text-brand-400 shadow-card transition hover:-translate-y-0.5 hover:border-brand-500/60 hover:text-brand-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500/60"
    >
      <ArrowUp className="size-4" />
    </button>
  );
}
